export const removeEmptyProperties = <T extends Object>(data: T) => {
  Object.keys(data).forEach((key) => {
    if (!data[key]) {
      delete data[key];
    }
  });
  return data;
};
